import { Box, Grid } from '@mui/material'
import domtoimage from 'dom-to-image'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import ShareRoundedIcon from '@mui/icons-material/ShareRounded'
import 'features/counter/doctor-schedule/table-style.css'
import moment from 'moment'
import MainButton from 'new-components/buttons/main-button'
import RadioButton from 'new-components/buttons/radio-button'
import PageModal from 'new-components/modal/page-modal'
import { Card, Col } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import DisplayDay from './display-day'

interface ShareInterface {
  data: any
  onClose: (e: any) => void
  branch: any
  date: any
  timeRange: string[]
}

export default function AppointmentScheduleShare(prop: ShareInterface) {
  const { t, i18n } = useTranslation()
  const lang = i18n?.language || 'th'
  const dispatch = useDispatch()
  const [shareType, setShareType] = useState('IMAGE')
  const [isContentVisible, setIsContentVisible] = useState(false)

  const { data, branch, date, timeRange } = prop
  const lad = data

  useEffect(() => {
    const timer = setTimeout(() => setIsContentVisible(true), 100)
    return () => clearTimeout(timer)
  }, [])



  const handleDownloadImage = async () => {
    const node = document.getElementById('div-schedule-share')
    if (!node) {
      console.error('Schedule container not found')
      return
    }

    const CAPTURE_ID = 'capture-artboard-for-schedule'
    const captureWrapper = document.createElement('div')
    captureWrapper.id = CAPTURE_ID
    captureWrapper.style.position = 'absolute'
    captureWrapper.style.top = '0'
    captureWrapper.style.width = '500px'
    captureWrapper.style.backgroundColor = 'white'

    const clone = node.cloneNode(true) as HTMLElement
    captureWrapper.appendChild(clone)

    clone.style.width = '100%'
    clone.style.height = 'auto'
    clone.style.overflow = 'visible'

    const nestedScrollables = clone.querySelectorAll('.custom-scroll, [id^="service-slider-container-"]') as NodeListOf<HTMLElement>
    nestedScrollables.forEach((el) => {
      el.style.setProperty('height', 'auto', 'important')
      el.style.setProperty('max-height', 'none', 'important')
      el.style.setProperty('overflow', 'visible', 'important')
    })

    const style = document.createElement('style')
    style.innerHTML = `
    #${CAPTURE_ID} *::-webkit-scrollbar { display: none !important; }
    #${CAPTURE_ID} * { scrollbar-width: none !important; -ms-overflow-style: none !important; }
  `
    document.head.appendChild(style)
    document.body.appendChild(captureWrapper)
    setTimeout(() => {
      domtoimage
        .toPng(captureWrapper)
        .then(function (dataUrl) {
          const link = document.createElement('a')
          const formattedDateForFile = moment(`${date.year}-${date.month}-${date.date}`, 'YYYY-M-D').format('DD-MM-YYYY')
          link.download = `${t('HOME.TITLE.SCHEDULE')}_${lad.doctorFullname}_${formattedDateForFile}.png`
          link.href = dataUrl
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch(function (error) {
          console.error('dom-to-image failed:', error)
        })
        .finally(() => {
          document.body.removeChild(captureWrapper)
          document.head.removeChild(style)
        })
    }, 300)
  }


  const handleShareClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    handleDownloadImage()
  }

  const generateTimeRange = (schedule: string) => {
    if (!schedule.includes(' - ')) return []
    const [startTime, endTime] = schedule.split(' - ')
    const startHour = parseInt(startTime.split(':')[0], 10)
    const endHour = parseInt(endTime.split(':')[0], 10)
    const range: string[] = []
    for (let i = startHour; i <= endHour; i++) {
      range.push(`${i.toString().padStart(2, '0')}:00`)
    }
    return range
  }

  return (
    <PageModal
      isOpen={true}
      size="M"
      title={t('HOME.TITLE.SCHEDULE')}
      handleClose={() => prop.onClose(false)}
      onCloseCancel={false}
      onCloseSubmit={true}
      onSubmit={{ onClick: () => null }}
      onCancel={{ onClick: () => prop.onClose(false) }}
      overflow={false}
    >
      <Box>
        <Grid container alignItems="center" spacing={2} display={'flex'} justifyContent={'space-between'}>
          <Grid item display={'flex'} flexDirection={'row'} gap={1}>
            <Box fontSize="16px" fontWeight="400">
              {t('DOCTOR_SCHEDULE.SHARE.DOCTOR')} {lad.doctorFullname}
            </Box>
            <Box fontSize="16px" fontWeight="400">
              {t('APPOINTMENT.HEADER.DAY')}
              {date.day}
              {t('APPOINTMENT.HEADER.AT')}{' '}
              {moment(
                `${lang === 'th' ? date.year + 543 : date.year}-${date.month}-${date.date}`,
                'YYYY-M-D'
              ).format('DD MMMM YYYY')}
            </Box>
          </Grid>
          <Grid item display={'flex'} justifyContent={'flex-end'}>
            <MainButton
              title={t('DOCTOR_SCHEDULE.BUTTON.SHARE')}
              type="primary"
              variant="outlined"
              onClick={handleShareClick}
              startIcon={<ShareRoundedIcon />}
            />
          </Grid>
        </Grid>
        <Grid item xs>
          <RadioButton
            name="share-row-radio-buttons-group"
            row
            value={shareType}
            onChange={e => e.target.value && setShareType(e.target.value)}
            options={[{ value: 'IMAGE', label: t('DOCTOR_SCHEDULE.SHARE.PICTURE') }]}
          />
        </Grid>

        <Box>
          <Box
            id="div-schedule-share"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              height: '65vh',
              width: '100%',
              overflowY: 'auto'
            }}
          >
            <Card className="appointment border-0 h-100">
              <Card.Body className="px-1 pb-1 pt-0 custom-scroll" style={{ zIndex: 2, position: 'relative' }}>
                <Col className="px-1 pb-1 pt-0 custom-scroll" style={{ zIndex: 2, position: 'relative' }}>
                  <Col className="px-1 pb-1 pt-0 overflow-hidden custom-scroll">
                    <DisplayDay
                      branch={branch}
                      branchId={branch?.branchId}
                      timeRange={generateTimeRange(data.doctorSchedule)}
                      listAppointmentDay={[lad]}
                      clinicIsClose={false}
                      type="share"
                    />
                  </Col>
                </Col>
              </Card.Body>
            </Card>
          </Box>
        </Box>
      </Box>
    </PageModal>
  )
}

